<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-19 10:58:14
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Status\Status.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-16 17:56:44
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_Status_list_title')"
    pad="0"
    widthClass="max-1000"
    backgroundClass="transparent"
  >
    <template v-slot:appendTitle>
      <!-- 流水号 -->
      <span class="text-h4 text--secondary"> - {{ Data["swift_number"] }}</span>
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <noContent v-if="Data['nodes'].length == 0" />

      <v-card
        elevation="0"
        class="pa-0 rounded-b-lg pb-1 mb-4"
        v-if="operating_staff && operating_staff.length"
      >
        <v-card-text class="pa-0 d-flex flex-column rounded">
          <v-sheet
            class="rounded-xl"
            color="primary"
            height="5"
            width="100%"
          ></v-sheet>
          <v-sheet class="pa-3 text-h6 text--primary">{{
            $t("label_essweb_Status_list_nextApproverLabel")
          }}</v-sheet>
          <v-sheet width="100%" class="pa-3 d-flex flex-row justify-end">
            <template v-for="(item, index) in operating_staff">
              <v-chip pill :key="`staff---${index}`" v-if="index < 2">
                <StaffAvatar
                  :src="item.staff_avatar"
                  :isTemp="item.is_temp"
                  left
                  :staff_name="item.preferred_name"
                />
                {{ $getCommonLangValue(item.preferred_name) }}
              </v-chip>
            </template>
            <span
              v-if="operating_staff.length > 2"
              class="text--secondary text-body-2"
            >
              ..{{ operating_staff.length - 2
              }}{{ $t("label_essweb_Status_list_usersLabel") }}</span
            >
          </v-sheet>
        </v-card-text>
      </v-card>
      <template v-for="(item, index) in allNodes">
        <v-sheet
          class="transparent py-3 d-flex justify-start flex-column"
          :key="`node---${index}`"
        >
          <v-sheet
            class="
              transparent
              d-flex
              flex-row
              justify-start
              align-center
              flex-grow-1
            "
          >
            <v-sheet width="5" height="30" color="primary"></v-sheet>
            <v-sheet class="text-title px-2 text--secondary transparent">{{
              $getDateTime(item.date, "YYYY/MM/DD")
            }}</v-sheet>
          </v-sheet>
          <template v-for="(ite, ind) in item['nodes']">
            <v-sheet
              :key="`nodesss---${ind}`"
              color="white"
              height="auto"
              class="
                rounded-lg
                my-3
                d-flex
                flex-grow-1
                pa-3
                flex-row flex-nowrap
              "
            >
              <v-sheet class="text--secondary text-subtitle-1">{{
                $getDateTime(ite["operate_utc_datetime"], "HH:mm")
              }}</v-sheet>
              <v-sheet
                color="grey lighten-3 mx-3"
                height="auto"
                width="2"
              ></v-sheet>
              <v-sheet height="auto" class="d-flex flex-column">
                <v-sheet class="text-h5 text--primary py-1">{{
                  $getCommonLangValue(ite.business_action)
                }}</v-sheet>
                <v-sheet class="text-h6 text--primary py-1"
                  >{{ $t("label_essweb_Status_list_handleLabel") }} :</v-sheet
                >
                <v-sheet
                  width="100%"
                  class="d-flex flex-row justify-start py-1"
                >
                  <template v-for="(it, index) in ite.operating_staff">
                    <v-chip pill :key="`staff---${index}`" v-if="index < 2">
                      <StaffAvatar
                        :src="it.staff_avatar"
                        left
                        :isTemp="it.is_temp"
                        :staff_name="it.preferred_name"
                      />
                      {{ $getCommonLangValue(it.preferred_name) }}
                    </v-chip>
                  </template>
                  <span
                    v-if="ite.operating_staff.length > 2"
                    class="text--secondary text-body-2"
                  >
                    ..{{ ite.operating_staff.length - 2
                    }}{{ $t("label_essweb_Status_list_usersLabel") }}</span
                  >
                </v-sheet>
                <v-sheet
                  class="d-flex flex-row justify-start flex-grow-1"
                  v-if="ite.operate_comment"
                >
                  <svg-icon size="24" fill="grey" iconClass="Doc" />
                  <v-sheet
                    width="100%"
                    class="text-ellipsis-4"
                    style="max-width: 400px"
                    >{{ ite.operate_comment }}</v-sheet
                  >
                </v-sheet>
              </v-sheet>
            </v-sheet>
          </template>
        </v-sheet>
      </template>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "Status",
  computed: {
    ...mapGetters(["companyLang"]),
    allNodes() {
      const that = this;
      let arr = JSON.parse(JSON.stringify(that.allDate));
      if (that.Data)
        that.Data["nodes"].map((item) => {
          let date = new Date(item.operate_utc_datetime).setHours(0, 0, 0, 0);
          arr.find((ele) => ele["date"] === date).nodes.push(item);
        });
      return arr;
    },
  },
  data() {
    return {
      operating_staff: [],
      allDate: [],
      page_params: null,
      Data: { swift_number: "", nodes: [] },
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.args)); //解密参数
    this.getDetail(this.page_params.id);
  },
  methods: {
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_form_records",
        url: "/approval/get-approval-process/",
        data: {
          uuid: uuid,
        },
        type: "client",
      }).then((res) => {
        if (res.data["nodes"] && res.data["nodes"].length) {
          let operate = res.data["nodes"][0];
          if (Number(operate["flow_task_node_status"]) == 0) {
            that.operating_staff = operate["operating_staff"];
            res.data["nodes"].splice(0, 1); // 刪除第一個
          }
          that.allDate = [];
          res.data["nodes"].map((item) => {
            let date = new Date(item.operate_utc_datetime).setHours(0, 0, 0, 0);
            if (!that.allDate.find((ele) => ele.date === date))
              that.allDate.push({ date: date, nodes: [] });
          });
          that.allDate = that.$UniqueArry(that.allDate, true);
        }
        that.Data = res.data;
      });
    },
  },
};
</script>